import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {dispatchAsync} from 'redux/common';
import {asyncType} from 'redux/helpers';
import {DialogCallbacks} from 'types/common';
import ApiService from 'api/ApiService';

/**
 *
 * @param url
 * @param type
 * @param options
 */
export const useDeleteApiDispatch = (
   url: string,
   type: ReturnType<typeof asyncType>,
   options?: DialogCallbacks & {getMethod?: any; data?: any}
) => {
   const dispatch = useDispatch();
   return useCallback(
      (data?: any) => {
         dispatch(
            dispatchAsync(url, type, {
               getMethod: ApiService.deleteSecureJson,
               ...options,
               data: data || options?.data,
            })
         );
      },
      [dispatch, url, type, options]
   );
};
